// extracted by mini-css-extract-plugin
export default {"mobile-frame":"Video_mobile-frame__vF80b","mobile-img":"Video_mobile-img__9-5us","video":"Video_video__jLeT5","title":"Video_title__g1fkL","desc":"Video_desc__Nx9Ca"};